import Component from "@ember/component"
import { get } from "@ember/object"
import { inject as service } from "@ember/service"
export default class StripeDowngradeUser extends Component.extend() {
  @service
  stripe

  @service
  session

  @service
  rpc

  click() {
    this.set("isUnsubscribing", true)
    let userId = get(this, "session.user.id")

    get(this, "rpc")
      .execute("user_cancel_subscription_from_app", {
        userId: userId,
        subscriptionId: get(this, "subscriptionId"),
      })
      .then((result) => {
        this.onSuccess(userId)
      })
  }

  onSuccess() {
    // analytics.track("Subscription - Started Trial", {
    //   price: this.get("price")
    // })
    // If we find isPro is being encoded in the documents e.g. (cardStack.meta.permissions),
    // Then we'll want to re-enable this. Otherwise, looks like we're good.
    // window.location.reload()
  }
}
